import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from "trans"

import {
    AlternativeTemplate,
    Template,
} from "app/types/model-types"

import { ID } from 'app/types/app-types'

import {
    css,
    Button,
    Grid,
    GridCell,
    Icon,
    Section,
    Field,
    FieldLabel,
} from "@bdfx/mergado-ui-kit"

import { updateInputValue as change } from "app/reducers/form"
import SelectGradient from 'shape-edit/forms/select-gradient'
import { selectFormValues } from 'app/reducers/form'
import { getFormName } from 'shape-edit/forms/helpers'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'

interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    change: typeof change
}

interface State {
    gradients: ID[]
    currentIndex: number,
}

class MultiGradientSelect extends Component<Props, State> {
    constructor(props) {
        super(props)

        if (props.form.background_gradient_ids) {
            const backgroundGradients = props.form.background_gradient_ids.split(',').filter(c => !!c && c !== '')
            this.state = {
                currentIndex: backgroundGradients.length,
                gradients: [...backgroundGradients, ''],
            }
        } else {
            this.state = {
                currentIndex: 0,
                gradients: [null],
            }
        }
    }


    render() {
        const { currentIndex, gradients } = this.state
        const {isAlt} = this.props

        const formName = getFormName(isAlt)

        return (
            <StyledDiv>
                <FieldLabel>{trans('select_gradients')}:</FieldLabel>

                <StyledGrid cols={'auto'}>
                    {gradients.map((gradientId, index) =>
                        <GridCell key={`gradient_${index}`}>
                            <SelectGradient
                                gradientId={gradientId}
                                handleChangeGradient={(gradient) => {
                                    let updatedGradients = [...gradients]

                                    if (gradient === null) {    //remove gradient
                                        updatedGradients = gradients.filter(g => g !== '' && `${g}` !== `${gradientId}`)
                                    } else {                    //update existing gradient
                                        updatedGradients[index] = gradient.id
                                    }

                                    this.setState({ gradients: updatedGradients })
                                    const backgroundGradients = updatedGradients.filter(gradient => !!gradient && gradient !== '').join(',')
                                    this.props.change(formName, 'background_gradient_ids', backgroundGradients)
                                }}
                            />
                        </GridCell>
                    )}
                    <GridCell>
                        <Button
                            color={'nocolor'}
                            type={'void'}
                            icon={<Icon type={'plus'} size={22} />}
                            onClick={() => this.setState({
                                currentIndex: currentIndex + 1,
                                gradients: [...gradients, null]
                            })}>
                            {trans('add')}
                        </Button>
                    </GridCell>
                </StyledGrid>
            </StyledDiv>
        )
    }
}

const StyledDiv = css('div')({
})

const StyledGrid = css(Grid)({
    gridGap: '5px',
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
    },
})

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
    }
}

export default connect(mapStateToProps, {
    change,
})(MultiGradientSelect)
